<template>
  <v-data-table :headers="headersQuestionTable"
                :items="questionsProps"
                :loading="loadingQuestionTerminate"
                :search="search"
  >
    <v-progress-linear height="2" slot="progress" color="valid" indeterminate/>
    <template v-slot:item.actions="{ item }">
      <v-radio :value="item.id"
               :key="item.id"
               color="valid"
      />
    </template>
  </v-data-table>
</template>

<script>
import questionPanelMixin from '@/components/questionnaires/fields/editPanels/questionPanelMixin'

export default {
  name: 'LikertQuestionEditPanel',
  mixins: [questionPanelMixin],
  props: {
    questionsProps: {
      type: Array,
      required: true
    },
    loadingQuestionTerminate: {
      type: Boolean,
      required: true
    },
    search: {
      type: String,
      required: false,
      default: ''
    }
  }
}
</script>
